import type * as lazyIndex from './lazyIndex';
import { LazyAction, LazyImport, LazyModule } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "MailStoreActions" */ './lazyIndex'),
    { name: 'MailStoreActions' }
);

export const lazyLoadAllRecipientsForItem: LazyAction<
    typeof lazyIndex.loadAllRecipientsForItem,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.loadAllRecipientsForItem);
export const lazyLoadItem: LazyAction<typeof lazyIndex.loadItem, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.loadItem);
export const lazyLoadItems: LazyAction<typeof lazyIndex.loadItems, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.loadItems);
export const lazyTryEvictListOnlyMessageBody: LazyImport<
    typeof lazyIndex.tryEvictListOnlyMessageBody,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.tryEvictListOnlyMessageBody);
export const lazyLoadConversation: LazyAction<
    typeof lazyIndex.loadConversation,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.loadConversation);
export const lazyIsForwardAllowed: LazyAction<
    typeof lazyIndex.isForwardAllowed,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.isForwardAllowed);

export {
    INITIAL_MAX_ITEMS_TO_RETURN,
    LOAD_MORE_INCREMENT,
    MAX_ITEMS_ALLOWED_TO_RETRIEVE,
} from './constants';
